import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ImageMasterService } from "src/app/Common/ImageMasterService/image-master.service";
import {
  HospitalDocMasterCreateBulkObjectDTO,
  HospitalDocMasterCreateBulkRequestDTO,
  HospitalDocMasterReadByMasterIdRequestDTO,
} from "src/app/hospital/BackOffice/hospital-master/hospital-detail/hospital-document/hospital-document.interface";
import { HospitalDocMasterService } from "src/app/hospital/BackOffice/hospital-master/hospital-detail/hospital-document/hospital-document.service";
import {
  HospitalMasterDTO,
  HospitalMasterReadByIdRequestDTO,
} from "src/app/hospital/BackOffice/hospital-master/hospital-master.interface";
import { HospitalMasterService } from "src/app/hospital/BackOffice/hospital-master/hospital-master.service";
import {
  DocumentVerificationSessionDeleteRequestDTO,
  DocumentVerificationSessionDTO,
  DocumentVerificationSessionReadByIdRequestDTO,
} from "src/app/Shared Utilities/documentVerificationSession/documentVerificationSession.interface";
import { DocumentVerificationSessionService } from "src/app/Shared Utilities/documentVerificationSession/documentVerificationSession.service";

@Component({
  selector: "app-hospital-doc-verification",
  templateUrl: "./hospital-doc-verification.component.html",
  styleUrls: ["./hospital-doc-verification.component.css"],
})
export class HospitalDocVerificationComponent {
  constructor(private route: ActivatedRoute, private router: Router) {}

  private imgUploadService = inject(ImageMasterService);
  private documentVerificationSessionServices = inject(
    DocumentVerificationSessionService
  );
  private hospitalDocMasterService = inject(HospitalDocMasterService);
  private hospitalMasterService = inject(HospitalMasterService);

  // Timer
  timerText: string = "00:00:00";
  totalSeconds: number = 0;
  timerInterval: any = null;

  isAllRequiredDocumentsUploaded: boolean = false;
  sessionInfo: DocumentVerificationSessionDTO | null = null;

  isDataLoading: boolean = true;
  isUploading: boolean = false;
  hospitalInfo: HospitalMasterDTO | null = null;

  // NEW
  showThankYouTemplate: boolean = false;

  // Documents
  documents = [
    {
      name: "PAN",
      displayName: "PAN",
      category: "Hospital Onboarding Verification",
      subtext: "Verify PAN matches hospital name",
      required: false,
      uploaded: false,
      uploading: false,
      fileName: "",
      fileUrl: "",
      isAlreadyUploaded: false,
      uploadedTime: "",
    },
    {
      name: "GST",
      displayName: "GST",
      category: "Hospital Onboarding Verification",
      subtext: "Verify GST matches PAN + address",
      required: false,
      uploaded: false,
      uploading: false,
      fileName: "",
      fileUrl: "",
      isAlreadyUploaded: false,
      uploadedTime: "",
    },
    {
      name: "Hospital-Registration-Certificate",
      displayName: "Hospital Registration Certificate",
      category: "Hospital Onboarding Verification",
      subtext: "Check registration number, name, address",
      required: false,
      uploaded: false,
      uploading: false,
      fileName: "",
      fileUrl: "",
      isAlreadyUploaded: false,
      uploadedTime: "",
    },
    {
      name: "Fire-NOC",
      displayName: "Fire NOC",
      category: "Hospital Onboarding Verification",
      subtext: "Verify validity & name",
      required: false,
      uploaded: false,
      uploading: false,
      fileName: "",
      fileUrl: "",
      isAlreadyUploaded: false,
      uploadedTime: "",
    },
    {
      name: "Biomedical-Waste-Certificate",
      displayName: "Biomedical Waste Certificate",
      category: "Hospital Onboarding Verification",
      subtext: "Check issue authority & validity",
      required: false,
      uploaded: false,
      uploading: false,
      fileName: "",
      fileUrl: "",
      isAlreadyUploaded: false,
      uploadedTime: "",
    },
    {
      name: "Pharmacy-License",
      displayName: "Pharmacy License",
      category: "Hospital Onboarding Verification",
      subtext: "Check license validity & hospital match",
      required: false,
      uploaded: false,
      uploading: false,
      fileName: "",
      fileUrl: "",
      isAlreadyUploaded: false,
      uploadedTime: "",
    },
    {
      name: "Owner-KYC-Aadhar",
      displayName: "Owner KYC Aadhar",
      category: "Hospital Onboarding Verification",
      subtext: "Check KYC validity & hospital match",
      required: false,
      uploaded: false,
      uploading: false,
      fileName: "",
      fileUrl: "",
      isAlreadyUploaded: false,
      uploadedTime: "",
    },
    {
      name: "Owner-Pancard",
      displayName: "Owner Pancard",
      category: "Hospital Onboarding Verification",
      subtext: "Check KYC validity & hospital match",
      required: false,
      uploaded: false,
      uploading: false,
      fileName: "",
      fileUrl: "",
      isAlreadyUploaded: false,
      uploadedTime: "",
    },
    {
      name: "Owner-GST Certificate",
      displayName: "GST Certificate",
      category: "Hospital Onboarding Verification",
      subtext: "Check KYC validity & hospital match",
      required: false,
      uploaded: false,
      uploading: false,
      fileName: "",
      fileUrl: "",
      isAlreadyUploaded: false,
      uploadedTime: "",
    },
  ];

  otherDocuments = [];

  uploadedCount = 0;
  totalDocuments = 0;
  uploadPercent = 0;

  verificationDocuments: { [key: string]: string } = {};

  ngOnInit(): void {
    this.route.paramMap.subscribe((param) => {
      const sessionId = param.get("sessionId");
      const hospitalId = param.get("hospitalId");

      if (sessionId && /^[0-9]+$/.test(sessionId)) {
        this.verifySessionAndGetData(Number(sessionId));
        this.getHospitalInfoByHospitalId(Number(hospitalId));
        this.getDocumentsByMasterId(
          "Hospital Onboarding Verification",
          Number(hospitalId)
        );
      } else {
        this.sessionInfo = null;
        this.isDataLoading = false;
      }
    });
  }

  verifySessionAndGetData(sessionId: number) {
    const payload: DocumentVerificationSessionReadByIdRequestDTO = {
      sessionId: sessionId,
    };

    this.documentVerificationSessionServices
      .DocumentVerificationSession_ExternalReadById(payload)
      .subscribe({
        next: (res) => {
          if (res && res.masterType === "Hospital") {
            const expiryTime = new Date(res.expiresOn).getTime();
            const currentTime = new Date().getTime();

            if (expiryTime > currentTime) {
              this.sessionInfo = res;
              this.calculateRemainingTime(res.expiresOn.toString());
              this.startTimer();
            } else {
              this.sessionInfo = null;
              this.stopTimer();
            }
          } else {
            this.sessionInfo = null;
            this.stopTimer();
          }

          this.isDataLoading = false;
        },
        error: (err) => {
          console.error(err);
          this.sessionInfo = null;
          this.stopTimer();
          this.isDataLoading = false;
        },
      });
  }

  getHospitalInfoByHospitalId(hospitalId: number) {
    const payload: HospitalMasterReadByIdRequestDTO = {
      hospitalId,
    };

    this.hospitalMasterService
      .HospitalMaster_ExternalReadById(payload)
      .subscribe({
        next: (res) => {
          this.hospitalInfo = res;
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  calculateRemainingTime(expiresOn: string) {
    const expiry = new Date(expiresOn).getTime();
    const now = new Date().getTime();

    const diff = Math.floor((expiry - now) / 1000);

    if (diff <= 0) {
      this.timerText = "00:00:00";
      this.totalSeconds = 0;
      return { timerText: "00:00:00", totalSeconds: 0 };
    }

    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;

    const timerText =
      (hours < 10 ? "0" + hours : hours) +
      ":" +
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds);

    this.timerText = timerText;
    this.totalSeconds = diff;

    return true;
  }

  startTimer() {
    this.stopTimer();

    this.timerInterval = setInterval(() => {
      if (this.totalSeconds <= 0) {
        this.stopTimer();
        this.sessionInfo = null;
        this.timerText = "00:00:00";
        return;
      }

      const hours = Math.floor(this.totalSeconds / 3600);
      const minutes = Math.floor((this.totalSeconds % 3600) / 60);
      const seconds = this.totalSeconds % 60;

      this.timerText = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
        seconds
      )}`;
      this.totalSeconds--;
    }, 1000);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  pad(num: number): string {
    return num.toString().padStart(2, "0");
  }

  isAllDocumentUploaded() {
    let isValid = true;

    for (const d of this.documents) {
      if (d.required && !d.isAlreadyUploaded && !d.fileUrl) {
        isValid = false;
        break;
      }
    }

    this.isAllRequiredDocumentsUploaded = isValid;
  }

  uploadDocument(index: number, event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.uploadDocumentAndStoreURL(file, index);
  }

  removeDocument(index: number) {
    this.documents[index].uploaded = false;
    this.documents[index].fileName = "";
    this.documents[index].uploadedTime = "";
    this.documents[index].uploading = false;
    this.documents[index].fileUrl = "";
    this.updateProgress();
    this.isAllDocumentUploaded();
  }

  updateProgress() {
    this.uploadedCount = this.documents.filter((d) => d.uploaded).length;
    this.uploadPercent =
      this.totalDocuments > 0
        ? (this.uploadedCount / this.totalDocuments) * 100
        : 0;
  }

  uploadDocumentAndStoreURL(file: File, index: number): Promise<string> {
    const doc = this.documents[index];
    doc.uploading = true;

    return new Promise((resolve, reject) => {
      this.imgUploadService.ImageMaster_ExternalUpload(file).subscribe({
        next: (res) => {
          const imgURL = res.fileURL;

          doc.uploading = false;
          doc.uploaded = true;
          doc.fileName = file.name;

          const now = new Date();
          doc.uploadedTime =
            now.toLocaleDateString() + " " + now.toLocaleTimeString();
          doc.fileUrl = imgURL;

          this.updateProgress();
          this.isAllDocumentUploaded();
          resolve(imgURL);
        },
        error: (err) => {
          console.error(err);
          doc.uploading = false;
          reject(err);
        },
      });
    });
  }

  async bulkUploadAllTheDocuments() {
    if (!this.sessionInfo) {
      alert("Session not exist.");
      this.refreshPage();
      return;
    } else {
      this.isUploading = true;

      const data: DocumentVerificationSessionReadByIdRequestDTO = {
        sessionId: this.sessionInfo.sessionId,
      };

      this.documentVerificationSessionServices
        .DocumentVerificationSession_ExternalReadById(data)
        .subscribe({
          next: (res) => {
            if (!res) {
              this.isUploading = false;
              this.sessionInfo = null;
              return;
            }

            const currentExpiryTime = new Date(res.expiresOn).getTime();
            const currentTime = new Date().getTime();

            if (currentExpiryTime <= currentTime) {
              this.isUploading = false;
              this.sessionInfo = null;
              this.stopTimer();
              return;
            }

            const allDocument = this.documents.filter((d) => d.fileUrl !== "");

            const docList: HospitalDocMasterCreateBulkObjectDTO[] =
              allDocument.map<HospitalDocMasterCreateBulkObjectDTO>((d) => {
                return {
                  masterType: d.category,
                  masterId: this.sessionInfo ? this.sessionInfo.masterId : 0,
                  docType: d.category,
                  docNo: d.name,
                  docDescription: d.subtext,
                  docPath: d.fileUrl,
                };
              });

            const payload: HospitalDocMasterCreateBulkRequestDTO = {
              docList: docList,
              actionUser: "Not Login",
            };

            this.hospitalDocMasterService
              .HospitalDocMaster_ExternalCreateBulk(payload)
              .subscribe({
                next: () => {
                  this.openSuccessModal();
                  this.deleteSession();
                  this.isUploading = false;
                },
                error: (err) => {
                  console.error(err);
                  this.isUploading = false;
                },
              });

            this.isDataLoading = false;
          },
          error: (err) => {
            console.error(err);
            this.isUploading = false;
            this.sessionInfo = null;
            this.stopTimer();
            this.isDataLoading = false;
          },
        });
    }
  }

  deleteSession() {
    if (this.sessionInfo) {
      const payload: DocumentVerificationSessionDeleteRequestDTO = {
        sessionId: this.sessionInfo.sessionId,
        actionUser: "Not Login",
      };

      this.documentVerificationSessionServices
        .DocumentVerificationSession_ExternalDelete(payload)
        .subscribe({
          next: () => {},
          error: (err) => {
            console.error(err);
          },
        });
    }
  }

  modalEl: any;
  modalInstance: any;

  ngAfterViewInit(): void {
    this.modalEl = document.getElementById("successPopper");

    // @ts-ignore
    this.modalInstance = new window.bootstrap.Modal(this.modalEl, {
      backdrop: "static",
      keyboard: false,
    });
  }

  openSuccessModal() {
    if (this.modalInstance) {
      this.modalInstance.show();
    }
  }

  closeSuccessModal() {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }

  // NEW
  showThankYouPage() {
    this.closeSuccessModal();
    this.stopTimer();
    this.showThankYouTemplate = true;
    this.sessionInfo = null;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  refreshPage() {
    window.location.reload();
  }

  isDocumentUploadedPresent(docType: string = "") {
    return Object.keys(this.verificationDocuments).includes(docType);
  }

  getDocumentsByMasterId(masterType: string, masterId: number) {
    const payload: HospitalDocMasterReadByMasterIdRequestDTO = {
      masterType,
      masterId,
    };

    this.hospitalDocMasterService
      .HospitalDocMaster_ExternalReadByMasterId(payload)
      .subscribe({
        next: (res) => {
          res.items.forEach((d) => {
            this.verificationDocuments[d.docNo] = d.docPath;
          });

          this.documents.map((d) => {
            d.isAlreadyUploaded = this.isDocumentUploadedPresent(d.name);
          });

          this.totalDocuments = this.documents.filter(
            (d) => !d.isAlreadyUploaded && d.fileUrl == ""
          ).length;

          this.updateProgress();
          this.isAllDocumentUploaded();
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }
}